import {runHPDestinationEmptySearchErrorExperiment} from './';

function hasEmptyDestination(destination) {
    return !destination;
}

function hasEmptyDestinationValues({destination}) {
    return hasEmptyDestination(destination);
}

function hasFilledDestination(destination) {
    return !hasEmptyDestination(destination);
}

/* istanbul ignore next */
function hasFilledDestinationValues({destination}) {
    return hasFilledDestination(destination);
}

function hasValidDestination(destination) {
    return hasFilledDestination(destination);
}

function hasValidDestinationValues({destination}) {
    return hasValidDestination(destination);
}

function showDestinationInputFieldError(media, destination, abacus, system, form) {
    const {
        settings: {
            isMobile
        }
    } = media;

    const {
        options: {
            allowErrorHighlighting
        },
        latestValues
    } = destination;

    return !isMobile && (
        allowErrorHighlighting && !hasValidDestinationValues(latestValues) ||
        runHPDestinationEmptySearchErrorExperiment(abacus, system, form, destination)
    );
}

export {
    hasEmptyDestination,
    hasEmptyDestinationValues,
    hasFilledDestination,
    hasFilledDestinationValues,
    hasValidDestination,
    hasValidDestinationValues,
    showDestinationInputFieldError
};
